<script>
import resources from './resources'

export default {
  name: 'agendas-search-results',
  mixins: [resources]
}
</script>

<template lang="pug">
    page
      h2(slot="title")
        span.first-line
          span.icon 
          | Agendar Consultas
        span.hifen  —
        span.second-line Resultado da pesquisa
      .col-xs-12.content(v-if="loading")
        spinner(:show="loading")
      .col-xs-12.content(v-if="!loading")
        .container-fluid
          .row
            .nav-tabs-wrapper
              tabs
            .col-xs-12.white-bg
              .row
                .col-xs-12.col-sm-8
                  h4(style='margin:15px 0px 10px 0px;') ENCONTRAMOS {{ pagination.total }} AGENDAS
                  .search-specs
                    | Para sua pesquisa por:
                    #filter-active.search-specs-filters
                      span.filter-active(v-for="item in searchedBy", v-if="typeof(item) == 'string'")
                          | {{ item }}
                      span(v-for="item in searchedBy", v-if="typeof(item) == 'object'")
                          span.filter-active(v-for="i in item")
                            |{{ i }}
                .col-xs-4
                  router-link(:to="{name: 'patient.agendas.search'}")
                    button.btn.find.hidden-xs.desktop-right
                      span.icon 
                      |  Nova Busca

                router-link(:to="{name: 'patient.agendas.search'}")
                  button.btn.find.hidden-sm.hidden-md.hidden-lg
                    span.icon 
                    |  Nova Busca
              .row
                .results.col-xs-12(v-if="loading")
                  spinner(:show="true")
                .results.col-xs-12(v-if="!loading")
                  item(:agenda="agenda", v-for="agenda in agendas", :key="agenda.id")
                .pagination
                  pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>



// WEBPACK FOOTER //
// src/app/patient/agendas/search/results/agendas.vue